import { useNavigate } from "react-router-dom";
import React, { useEffect, useCallback } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { useUserQuery } from "../../hooks/api_hooks/useUserQuery";

const Success = () => {
  const navigate = useNavigate();
  const { refetch } = useUserQuery();

  useEffect(() => {
    document.title = "Success | Kloudscan";
  }, []);

  const handleNavigation = useCallback((user) => {
    if (!user) {
      navigate("/", { replace: true });
      return;
    }

    const hasPersonalInfo = Boolean(user.personal_information);
    const hasAuthorization = Boolean(user.authorization_signed);

    if (!hasPersonalInfo) {
      navigate("/profile/personal-information", {
        state: { fromSuccess: true },
        replace: true,
      });
    } else if (!hasAuthorization) {
      navigate("/profile/authorization", {
        state: { fromSuccess: true },
        replace: true,
      });
    } else {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    let attempts = 0;
    const MAX_ATTEMPTS = 10;
    const BASE_DELAY = 300;

    const pollUntilActive = async () => {
      while (attempts < MAX_ATTEMPTS) {
        if (attempts > 0) {
          const delay = Math.min(BASE_DELAY * 2 ** (attempts - 1), 5000);
          await new Promise((resolve) => setTimeout(resolve, delay));
        }

        attempts += 1;

        try {
          const result = await refetch({ cancelRefetch: false });
          const currentUser = result?.data?.user;
          const subState = currentUser?.stripe_data?.subscription?.toLowerCase?.();

          console.log(`Attempt ${attempts}: ${subState}`);

          if (subState === "active") {
            handleNavigation(currentUser);
            return;
          }
        } catch (err) {
          console.error("Error polling for subscription:", err);
        }
      }

      console.warn("Timed out waiting for active subscription");
      handleNavigation(null);
    };

    pollUntilActive();
  }, [refetch, handleNavigation]);

  return (
    <Backdrop
      sx={(theme) => ({
        color: "#fff",
        zIndex: theme.zIndex.drawer + 1,
      })}
      open
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default Success;
